import classNames from 'classnames';
import styles from './ServiceNavigation.module.scss';
import { UI_Link } from 'ui/components/1-atoms/Action/Link/Link';

export interface ServiceNavigationProps {
	className?: string;
	serviceNavigationItems?: {
		url: string;
		name: string;
		target?: string;
	}[];
	mobile?: boolean;
	heading: string;
}

export const UI_ServiceNavigation = ({ className, serviceNavigationItems, mobile, heading }: ServiceNavigationProps) => {
	if (!serviceNavigationItems) return null;
	return (
		<nav aria-label={heading} className={classNames(styles.ServiceNavigation, { [styles.ServiceNavigation___mobile]: mobile }, className)}>
			<ul className={classNames(styles.ServiceNavigation_list)}>
				{serviceNavigationItems.map((link, index) => (
					<li key={index} className={classNames(styles.ServiceNavigation_item)}>
						<UI_Link className={styles.ServiceNavigation_link} url={link.url} target={link.target}>
							{link.name}
						</UI_Link>
					</li>
				))}
			</ul>
		</nav>
	);
};
